<template>
  <ion-grid fixed class="ion-margin-top">
    <div
      class="ion-margin-bottom"
      v-if="!routing.startsWith('ARAG Case Management')">
      <roodie :expression="'happy'" />
    </div>
    <template v-if="routing === 'Medgate'">
      <b>So funktioniert ein Arztgespräch per Video oder telefonisch...</b>
      <anleitung-medgate-text />
    </template>
    <template v-else-if="routing === 'BetterDoc'">
      <b>So geht es weiter...</b>
      <p>
        1. Sie haben die Wahl. Ihr Roodie.Check (Zusammenfassung Ihres
        Anliegens) wird mit Ihrer Zustimmung an unseren langjährig erfahrenen
        Partner
        <a href="#" @click.prevent="showBetterDoc()"> BetterDoc </a>
        übergeben, damit der/die passende Arzt/Klinik für Sie gesucht werden
        kann. Sie können darauf aber auch verzichten.
      </p>
      <p>
        2. Sollten noch Informationen nötig sein, so kontaktiert Sie das
        medizinische Fachpersonal von BetterDoc.
      </p>
      <p>
        3. Spätestens nach 48 Stunden erhalten Sie drei Empfehlungen für die
        Ärzte oder Kliniken, die optimal passen. Inklusive Terminvereinbarung.
      </p>
      <p>
        4. Während der kompletten ärztlichen Behandlung begleitet Sie ein
        medizinisch geschulter Spezialist von BetterDoc.
      </p>
      <p>
        Das Service ist für Sie kostenlos und umfasst ein Anamnesegespräch und
        die Suche nach einer/m geeigneten Arzt/Klinik einschließlich
        Terminvereinbarung.
      </p>
      <p>
        Wenn Sie akut ärztlichen Rat oder Hilfe benötigen, wenden Sie sich bitte
        an den ärztlichen Bereitschaftsdienst. Im Notfall rufen Sie bitte die
        Notrufnummer <a href="tel:112">112</a> an.
      </p>
    </template>
    <template v-else-if="routing === 'ZTK'">
      <b>So geht es weiter...</b>
      <p>
        <ion-row>
          <ion-col size="auto">
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_artzwechsel.svg')" />
          </ion-col>
          <ion-col>
            Wählen Sie die Praxis der Zahnärztlichen Tageskliniken, die für Sie
            am besten gelegen ist.
          </ion-col>
        </ion-row>
      </p>
      <p>
        <ion-row>
          <ion-col size="auto">
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_telefon.svg')" />
          </ion-col>
          <ion-col>
            Buchen Sie gleich online oder telefonisch einen Termin.
          </ion-col>
        </ion-row>
      </p>
      <p>
        <ion-row>
          <ion-col size="auto">
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_verlaufskontrolle.svg')" />
          </ion-col>
          <ion-col>
            Geben Sie in der Zahnarztpraxis an, dass Sie bei der ARAG
            krankenversichert sind. Damit können Sie den Service der direkten
            Abrechnung zwischen der Zahnarztpraxis und der ARAG nutzen. Sie
            müssen nicht in Vorleistung gehen.
          </ion-col>
        </ion-row>
      </p>
      <b>Beste zahnmedizinische Versorgung - 14 x in Süd-Deutschland</b>
    </template>
    <!-- <template v-else-if="routing === 'ZTK'">
      <b>So geht es weiter...</b>
      <p>
        <ion-row>
          <ion-col size="auto">
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_verlaufskontrolle.svg')"
            />
          </ion-col>
          <ion-col>
            Sie haben die Wahl:<br />
            - Buchen Sie schnell und bequem gleich online einen Termin. Sie
            erhalten gleich eine Terminbestätigung per Mail und wir schicken
            Ihnen 24 Stunden vor Ihrem Zahnarzt-Termin noch eine kleine
            Erinnerung.<br />
            - Oder wählen Sie „Termin anfragen“ und geben Sie einfach jene Tage
            und Zeifenster an, die für Sie nicht möglich sind. Das Team der
            Zahnärztlichen Tageskliniken kontaktiert Sie umgehend, um einen
            Termin mit Ihnen zu vereinbaren.
          </ion-col>
        </ion-row>
      </p>
      <p>
        <ion-row>
          <ion-col size="auto">
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_erstdiagnose.svg')"
            />
          </ion-col>
          <ion-col>
            Teilen Sie Ihren Roodie.Check mit den Experten der Zahnärztlichen
            Tageskliniken, damit sie diese auf den Termin mit Ihnen gut
            vorbereiten können.
          </ion-col>
        </ion-row>
      </p>
    </template> -->
    <template
      v-else-if="
        routing === 'ARAG Case Management Zahn' &&
        ['toothTreatmentplan'].includes(selectedCondition.name)
      ">
      <b>So geht es weiter...</b>
      <p>
        <ion-row>
          <ion-col size="auto">
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_artzwechsel.svg')" />
          </ion-col>
          <ion-col>
            &nbsp;<b>1.</b> Die ARAG Gesundheitsassistenten prüfen für Sie, ob
            die Behandlungskosten in Ihrem Versicherungsvertrag abgedeckt sind.
          </ion-col>
        </ion-row>
      </p>
      <template v-if="answersObject['be-27']">
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_telefon.svg')" />
            </ion-col>
            <ion-col>
              &nbsp;<b>2.</b> Sie erhalten direkt von Roodie eine Nachricht über
              die Kostenzusage der ARAG oder falls von Ihnen gewünscht, werden
              Sie von
              <a href="#" @click.prevent="showQualitySmile()">Quality Smile</a>,
              dem Zahnlaborpartner der ARAG, anschließend kontaktiert.
            </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="
                  require('@lib/assets/icons/icon_verlaufskontrolle.svg')
                " />
            </ion-col>
            <ion-col>
              &nbsp;<b>3.</b> Oder ein ARAG Gesundheitsassistent meldet sich, um
              Ihnen alternative Lösungen aufzuzeigen und bei der Organisation
              Ihrer Behandlung behilflich zu sein.
            </ion-col>
          </ion-row>
        </p>
      </template>
      <template v-else>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_telefon.svg')" />
            </ion-col>
            <ion-col>
              &nbsp;<b>2.</b> Ein ARAG Gesundheitsassistent kontaktiert Sie
              anschließend und gibt Ihnen ein Feedback und zeigt Ihnen bei
              Bedarf alternative Lösungen auf.
            </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="
                  require('@lib/assets/icons/icon_verlaufskontrolle.svg')
                " />
            </ion-col>
            <ion-col>
              &nbsp;<b>3.</b> Anschließend hilft er Ihnen auch gerne bei der
              Organisation Ihrer Behandlung.
            </ion-col>
          </ion-row>
        </p>
      </template>
    </template>
    <template
      v-else-if="
        routing === 'ARAG Case Management Zahn' &&
        ['toothCosmetic', 'toothJaw'].includes(selectedCondition.name)
      ">
      <b>So geht es weiter...</b>
      <p>
        <ion-row>
          <ion-col size="auto">
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_artzwechsel.svg')" />
          </ion-col>
          <ion-col>
            &nbsp;<b>1.</b> Die ARAG Gesundheitsassistenten nehmen sich Ihrem
            Anliegen an, um Sie gezielt zu unterstützen<template
              v-if="selectedCondition.value === 'Zahnersatz'"
              >.</template
            ><template v-else
              >, denn es gibt mittlerweile verschiedene
              <a
                href="#"
                @click.prevent="
                  openInfoModal(
                    'Alle Behandlungen müssen im Rahmen der kassenärztlichen Versorgung erfolgen, also von Zahnärzten oder Kieferorthopäden mit Kassenzulassung durchgeführt und im Rahmen der kassenärztlichen Vorschriften abgerechnet werden. Demnach sind privatärztliche Rechnungen nach der Gebührenordnung für Zahnärzte (GOZ) nur dann erstattungsfähig, wenn die medizinisch notwendigen Maßnahmen von Zahnärzten oder Kieferorthopäden mit Kassenzulassung durchgeführt werden und nicht im Rahmen der kassenärztlichen Versorgung abgerechnet werden können. Da sich die ARAG nur an Kosten von medizinischen Heilbehandlungen beteiligen kann, ist eine Erstattung für kosmetische kieferorthopädische Behandlungen nicht möglich.'
                  )
                "
                >Anbieter und Behandlungsverfahren</a
              >
              auf dem Markt.</template
            ></ion-col
          >
        </ion-row>
      </p>
      <template v-if="answersObject['be-27']">
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_telefon.svg')" />
            </ion-col>
            <ion-col>
              &nbsp;<b>2.</b> Sie erhalten entweder direkt von Roodie eine
              Nachricht über die Kostenzusage der ARAG und werden von
              <a href="#" @click.prevent="showQualitySmile()">Quality Smile</a>,
              dem Zahnlaborpartner der ARAG, anschließend kontaktiert.
            </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="
                  require('@lib/assets/icons/icon_verlaufskontrolle.svg')
                " />
            </ion-col>
            <ion-col>
              &nbsp;<b>3.</b> Oder ein ARAG Gesundheitsassistent meldet sich, um
              Ihnen alternative Lösungen aufzuzeigen und bei der Organisation
              Ihrer Behandlung behilflich zu sein.
            </ion-col>
          </ion-row>
        </p>
      </template>
      <template v-else>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_telefon.svg')" />
            </ion-col>
            <ion-col>
              &nbsp;<b>2.</b> Ein ARAG Gesundheitsassistent kontaktiert Sie, um
              Ihr Anliegen aufzunehmen.
            </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_erstdiagnose.svg')" />
            </ion-col>
            <ion-col>
              &nbsp;<b>3.</b> Anschließend zeigt er Ihnen mögliche Lösungen auf
              und prüft für Sie, ob die Behandlung in Ihrem Versicherungsvertrag
              abgedeckt ist.
            </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="
                  require('@lib/assets/icons/icon_verlaufskontrolle.svg')
                " />
            </ion-col>
            <ion-col>
              &nbsp;<b>4.</b> Ihr ARAG Gesundheitsassistent hilft Ihnen dann
              gerne bei der Organisation Ihrer Behandlung.
            </ion-col>
          </ion-row>
        </p>
      </template>
    </template>
    <template v-else-if="routing === 'ARAG Case Management Zahn'">
      <b>So geht es weiter...</b>
      <p>
        <ion-row>
          <ion-col size="auto">
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_verlaufskontrolle.svg')" />
          </ion-col>
          <ion-col>
            &nbsp;<b>1.</b> Ihr Roodie.Check wird mit Ihrer Zustimmung an die
            ARAG Gesundheitsassistenten übergeben.</ion-col
          >
        </ion-row>
      </p>
      <template v-if="answersObject['be-27']">
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_telefon.svg')" />
            </ion-col>
            <ion-col>
              &nbsp;<b>2.</b> Sie erhalten entweder direkt von Roodie eine
              Nachricht über die Kostenzusage der ARAG und werden von
              <a href="#" @click.prevent="showQualitySmile()">Quality Smile</a>,
              dem Zahnlaborpartner der ARAG, anschließend kontaktiert.
            </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="
                  require('@lib/assets/icons/icon_verlaufskontrolle.svg')
                " />
            </ion-col>
            <ion-col>
              &nbsp;<b>3.</b> Oder ein ARAG Gesundheitsassistent meldet sich, um
              Ihnen alternative Lösungen aufzuzeigen und bei der Organisation
              Ihrer Behandlung behilflich zu sein.
            </ion-col>
          </ion-row>
        </p>
      </template>
      <template v-else>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_telefon.svg')" />
            </ion-col>
            <ion-col>
              &nbsp;<b>2.</b> Ein ARAG Gesundheitsassistent kontaktiert Sie
              telefonisch. Im persönlichen Gespräch wird Ihr Anliegen genau
              besprochen und Ihre Wünsche werden aufgenommen.
            </ion-col>
          </ion-row>
        </p>
        <p>
          <ion-row>
            <ion-col size="auto">
              <ion-icon
                size="large"
                :src="require('@lib/assets/icons/icon_artzwechsel.svg')" />
            </ion-col>
            <ion-col>
              &nbsp;<b>3.</b> Ihr ARAG Gesundheitsassistent prüft Ihr Anliegen
              anhand bestimmter Kriterien und erstellt einen Lösungsansatz für
              Sie. Er hilft Ihnen auch bei der Organisation der weiterführenden
              Behandlung.
            </ion-col>
          </ion-row>
        </p>
        <ion-row class="ion-align-items-center">
          <ion-col>
            <ion-button
              size="small"
              fill="clear"
              class="ion-text-wrap ion-no-padding"
              @click="openKostenerstattungModal"
              >Kostenrückerstattung&nbsp;
              <ion-icon :icon="helpCircle" />
            </ion-button>
          </ion-col>
        </ion-row>
      </template>
    </template>
    <template v-else-if="routing === 'Quality Smile'">
      <b>So geht es weiter...</b>
      <p>
        <ion-row>
          <ion-col size="auto">
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_verlaufskontrolle.svg')" />
          </ion-col>
          <ion-col>
            Mit Ihrer Zustimmung erhält der Patientenservice von
            <a href="#" @click.prevent="showQualitySmile()">Quality Smile</a>
            Ihren Roodie.Check und Ihren Behandlungsplan, um Sie zu kontaktieren
            und bei Ihrem Anliegen zu unterstützen.
          </ion-col>
        </ion-row>
      </p>
      <p>
        <ion-row>
          <ion-col size="auto">
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_artzwechsel.svg')" />
          </ion-col>
          <ion-col>
            Der Patientenservice prüft Ihren Behandlungsplan und erstellt auf
            Wunsch auch einen Kostenvoranschlag für Sie.
          </ion-col>
        </ion-row>
      </p>
      <p>
        <ion-row>
          <ion-col size="auto">
            <ion-icon
              size="large"
              :src="require('@lib/assets/icons/icon_weiter_behandlung.svg')" />
          </ion-col>
          <ion-col>
            Auf Wunsch empfiehlt Ihnen Quality Smile auch passende
            Zahnarztpraxen aus deren Netzwerk. Sie können dann direkt mit der
            Praxis Kontakt aufnehmen, um einen Termin zu vereinbaren oder das
            Patientenservice unterstützt Sie auch dabei.
          </ion-col>
        </ion-row>
      </p>
      <p>Das Service ist für Sie kostenlos.</p>
    </template>
    <template v-else>
      <component
        v-if="routing"
        :is="'Erklaerung' + routing.replaceAll(' ', '')"
        from="chat"></component>
      <ion-row>
        <ion-col v-if="routing !== 'ARAG Case Management Mental'">
          <ion-button
            size="small"
            fill="clear"
            class="ion-text-wrap ion-no-padding"
            @click="
              $router.push({
                name: routingManual + '-anleitung',
                params: { from: 'chat' },
              })
            "
            >So funktioniert's&nbsp;
            <ion-icon :icon="helpCircle" />
          </ion-button>
        </ion-col>
      </ion-row>
    </template>
    <div class="ion-text-right">
      <ion-button
        @click="
          routing === 'Medgate'
            ? (showPrivacy = true)
            : $emit('done', { value: routing, id: question.id })
        "
        fill="outline"
        >Weiter</ion-button
      >
    </div>
  </ion-grid>
  <ion-modal
    :is-open="showPrivacy"
    :css-class="['c-autoheight-modal']"
    @didDismiss="showPrivacy = false">
    <ion-page>
      <div class="ion-padding modal-content ion-text-center u-color-primary">
        <modal-close />
        <roodie fillOuter="#5E58BE" :expression="'happy'" />
        <h6>
          <b v-if="routing === 'Medgate'">
            Ihr digitaler Arztbesuch wird von Medgate, dem Spezialisten für
            Fernbehandlungen, ausgeführt.
          </b>
          <b v-else>
            Bitte bestätigen Sie, dass Sie mit den Datenschutzbestimmungen
            einverstanden sind.
          </b>
        </h6>
        <div class="ion-margin-top">
          <component
            v-if="routing"
            :is="'Privacy' + routing.replaceAll(' ', '')"
            @checked="isPrivacyChecked = true"
            @unchecked="isPrivacyChecked = false"></component>
        </div>
        <div class="ion-text-center">
          <ion-button
            @click="
              modalController.dismiss();
              $emit('done', { value: routing, id: question.id });
            "
            fill="outline"
            :disabled="!isPrivacyChecked"
            >Weiter</ion-button
          >
        </div>
      </div>
    </ion-page>
  </ion-modal>
</template>

<script>
import {
  IonButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonModal,
  IonPage,
  modalController,
} from "@ionic/vue";
import { helpCircle } from "ionicons/icons";
// import ErklaerungMedgate from "@arag/components/ErklaerungMedgate";
import AnleitungMedgateText from "@arag/components/AnleitungMedgateText";
import ErklaerungBetterDoc from "@arag/components/ErklaerungBetterDoc";
import ErklaerungZTK from "@arag/components/ErklaerungZTK";
import ErklaerungMedicalContact from "@arag/components/ErklaerungMedicalContact";
import ErklaerungARAGCaseManagementZahn from "@arag/components/ErklaerungAragZahn";
import ErklaerungARAGCaseManagementMental from "@arag/components/ErklaerungAragMental";
import Roodie from "@lib/components/svg/Roodie";
import ModalClose from "@lib/components/ModalClose";
import InfoModal from "@lib/components/InfoModal";
import QualitySmile from "@arag/views/QualitySmile";
import BetterDoc from "@arag/views/BetterDoc";

import PrivacyMedgate from "@arag/components/Privacy";
import PrivacyARAGCaseManagement from "@arag/components/PrivacyArag";
import PrivacyARAGCaseManagementZahn from "@arag/components/PrivacyAragZahn";
import PrivacyBetterDoc from "@arag/components/PrivacyBetterDoc";
import PrivacyZTK from "@arag/components/PrivacyZTK";

import KostenerstattungModal from "@arag/components/KostenerstattungAragZahnModal";

export default {
  emits: ["done"],
  props: {
    question: {
      required: true,
      type: Object,
    },
    routing: {
      required: true,
      type: String,
    },
    selectedCondition: {
      required: false,
      type: Object,
      default: null,
    },
    answersObject: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  components: {
    IonButton,
    IonIcon,
    // ErklaerungMedgate,
    AnleitungMedgateText,
    ErklaerungBetterDoc,
    ErklaerungZTK,
    ErklaerungMedicalContact,
    ErklaerungARAGCaseManagementZahn,
    ErklaerungARAGCaseManagementMental,
    IonGrid,
    IonRow,
    IonCol,
    Roodie,
    ModalClose,
    IonModal,
    IonPage,

    PrivacyMedgate,
    PrivacyARAGCaseManagement,
    PrivacyARAGCaseManagementZahn,
    PrivacyBetterDoc,
    PrivacyZTK,
  },
  data() {
    return {
      showPrivacy: false,
      isPrivacyChecked: false,
    };
  },
  computed: {
    name() {
      let result = this.routing;
      if (this.routing === "ZTK") {
        result = "Zahnärztliche Tageskliniken";
      }
      return result;
    },
    routingManual() {
      let result = this.routing;
      if (this.routing === "ARAG Case Management Zahn") {
        result = "arag-zahn";
      } else {
        result = result.toLowerCase();
      }
      return result;
    },
  },
  methods: {
    async showQualitySmile() {
      const modal = await modalController.create({
        component: QualitySmile,
        componentProps: {
          from: "chat",
        },
      });
      return modal.present();
    },
    async showBetterDoc() {
      const modal = await modalController.create({
        component: BetterDoc,
        componentProps: {
          from: "chat",
        },
      });
      return modal.present();
    },
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
    async openInfoModal(text, image) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "c-tip-modal",
        componentProps: {
          title: "Tipp",
          imagePath: image ? require("@lib/assets/img/tips/" + image) : "",
          showImage: true,
          text: text,
          closeText: "Tipp schließen",
        },
      });
      return modal.present();
    },
  },
  setup() {
    return {
      helpCircle,
      modalController,
    };
  },
};
</script>

<style></style>
